import React from 'react';

import { Alert } from '@medely/ui-kit';
import { WarningAlertProps } from './interface';

export const WarningAlert = ({ description }: WarningAlertProps) => {
  return <Alert hideCloseIcon severity="warning" showIcon={false} description={description} />;
};
